import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-detail-row',
    templateUrl: './detail-row.component.html',
    styleUrls: ['./detail-row.component.scss'],
    standalone: false
})
export class DetailRowComponent {
    @Input() icon: string = '';
    @Input() label: string = '';
    @Input() value: string = '';

    /**
     * Deja que el valor ocupe varias líneas en vez de truncarse con ellipsis.
     * Para credenciales, un valor cortado es inservible: no se puede leer ni
     * dictar. Es opt-in para no cambiarle el layout a quien ya lo usa en una
     * sola línea (emails, DNI, teléfonos).
     */
    @Input() wrapValue = false;
}
